export default {"src":"/_next/static/media/ic-price.4bc93fa0.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};